import React from 'react';
import CompleteSolution from '../Survey/CompleteSolution';

const Solutions = () => {
  return (
    <div className="manager-solutions">
      <CompleteSolution />
    </div>
  );
};

export default Solutions;
